import React, { useState, useEffect, useRef } from "react";
import {
  Card,
  CardBody,
  Form,
  Col,
  Row,
  CardSubtitle,
  Alert,
  Container,
  Progress,
  Spinner,
} from "reactstrap";
//import './style.css';
import Breadcrumbs from "../../../components/Common/Breadcrumb.js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { useNavigate, useParams } from "react-router-dom";
import Dropzone from "react-dropzone";
import axios from "axios";
import { BACKEND_URL_LOG, BACKEND_URL_PORTAIL } from "../../../config/const.js";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import moment from "moment";
import "./Styles.css";

// 🔓 Rôles "compounding" additifs : ils ne font pas partie de la sélection unique
// (admin / adminClient / preparer) et se cumulent librement avec le rôle principal.
const ADDITIVE_COMPOUNDING_ROLES = ["verificator", "inventory"];

const UpdateUser = () => {
  const { t } = useTranslation();

  document.title = t("updateUserTitle");
  const [restore, setRestore] = useState(false);
  const [actifUser, setActifUser] = useState(false);
  const [selectedFiles, setselectedFiles] = useState(null);
  const [selectedGroups, setSelectedGroups] = useState([]); // Store the selected listOfGroups
  const [listOfGroup, setListOfGroups] = useState([]); // Store the currently selected listOfGroup
  const [organizations, setOrganization] = useState([]);
  const [originalOrganizations, setOriginalOrganisations] = useState([]);
  const [listRoleOfGroup, setListRoleOfGroup] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [originalPassword, setOriginalPassword] = useState("");
  const { userId } = useParams();
  const [changedSignature, setChangedSignature] = useState(false);
  const [groupIdSelected, setGroupIdSelected] = useState("");
  const [passwordStrength, setPasswordStrength] = useState({
    value: 0,
    text: "",
    color: "",
  });
  const [other, setOther] = useState("");
  const [showOther, setShowOther] = useState(false);
  const [checkreason, setCheckReason] = useState(null);
  const [passwordMatch, setPasswordMatch] = useState(true);
  const [passwordChange, setPasswordChange] = useState(false);
  const [userNameError, setUserNameError] = useState(null);
  const [passwordError, setPasswordError] = useState(null);
  const [firstNameError, setFirstNameError] = useState(null);
  const [lastNameEroor, setLastNameError] = useState(null);
  const [phoneError, setPhoneError] = useState(null);
  const [emailError, setEmailError] = useState(null);
  const [validEmailError, setValidEmailError] = useState(null);
  const [userAddedMessage, setUserAddedMessage] = useState(null);
  const [userNameExistsError, setUserNameExistsError] = useState(null);
  const [listAvailableUser, setListAvailableUser] = useState([]);
  const [emailExistsError, setEmailExistsError] = useState(null);
  const [selectedGroupsError, setSelectedGroupsError] = useState(null);
  const [blockedUser, setBlockedUser] = useState(false);
  const [disabledBlockedUser, setDisabledBlockedUser] = useState(true);
  const [initialUserBlockedStatus, setInitialUserBlockedStatus] = useState(false);
  const [loadingPage, setLoadingPage] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
  //const [isEnabled, setIsEnabled] = useState(false);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [currentReason, setCurrentReason] = useState(false);
  const [isClicked, setIsClicked] = useState(false);

  const [newUser, setNewUser] = useState("reason");
  const otherInputRef = useRef(null);
  const handleRemoveFile = () => {
    // Remove the selected file from the state
    setChangedSignature(true);
    setselectedFiles(null);
  };
  const [raison,setRaison] = useState(
     [{
      value: "reason",
      label: t("reason"),
    },
    {
      value: "depart",
      label: t("depart"),
    },
    {
      value: "absenceTemp",
      label: t("absenceTemp"),
    }, 
    {
      value: "probation",
      label: t("probation"),
    },
    {
      value: "other",
      label: t("other"),
    },
  ]);
  const [formData, setFormData] = useState({
    id: "",
    app:"portail",
    username: "",
    lastname: "",
    firstname: "",
    password: "",
    email: "",
    phone: "",
    phone2: "",
    isEnabled: true,
    isAvailable: false,
    has2Fa: false,
    passwordChange: true,
    listOfGroups: listOfGroup,
    signature: null,
    listRoleOfGroup: listRoleOfGroup,
    filesNames: selectedFiles, // Attribut supplémentaire pour les fichiers
    language: localStorage.getItem("lang")
      ? localStorage.getItem("lang")
      : "en",
    currentOrg: localStorage.getItem("currentOrg"),
  });
  useEffect(() => {
    
    handleChangeActifUser();
  }, [actifUser]);
 
useEffect(() => {
  const handleScroll = () => {
    setShowScrollTop(window.pageYOffset > 300);
  };

  window.addEventListener("scroll", handleScroll);
  return () => window.removeEventListener("scroll", handleScroll);
}, []);
  useEffect(() => {
    if (showOther) {
      otherInputRef.current.focus();
    }
  }, [showOther]);
  useEffect(() => {
    getRaisonAvailableUser(userId);
    const fetchOrganization = async () => {
      try {
        // Récupération des rôles affectés pour l'utilisateur
        const userRoles = await axios.get(
          `${BACKEND_URL_PORTAIL}api/getGroupRolesAffected/` + userId,
          config
        );
  
        let groups = [];
        let registreRoles = [];
        let controleRoles = [];
        let compounentRoles = [];
  
        if (userRoles.length > 0) {
          // Extraction des rôles cochés pour quessRegistre
          registreRoles = userRoles.map((org) =>
            org.quessRegistre
              .filter((role) => role.checked)
              .map((role) => ({
               
                groupId: org.groupId,
                itemId: role.id,
              }))
          );
  
          // Extraction des rôles cochés pour quessControle
          controleRoles = userRoles.map((org) =>
            org.quessControle
              .filter((role) => role.checked)
              .map((role) => ({
            
                groupId: org.groupId,
                itemId: role.id,
              }))
          );

          // Extraction des rôles cochés pour quessCompounent
          compounentRoles = userRoles.map((org) =>
            org.quessCompounent
              .filter((role) => role.checked)
              .map((role) => ({

                groupId: org.groupId,
                itemId: role.id,
              }))
          );
  
          groups = userRoles.map((org) => org.groupId);
        }
        var flattenedOptions = [...registreRoles, ...controleRoles, ...compounentRoles].flat();
        setListRoleOfGroup(flattenedOptions);
        setSelectedGroups(userRoles);
        // Récupération des groupes non affectés
        const response = await axios.get(
          `${BACKEND_URL_PORTAIL}api/getGroupNotAffectedPortail/` + userId,
          config
        );
        // Récupération des informations utilisateur
        const userInfos = await axios.get(
          `${BACKEND_URL_PORTAIL}api/getUserById/` + userId +"/"+localStorage.getItem("currentOrg"),
          config
        );
        
        if (userInfos.signature && userInfos.signature !== "") {
          const cleanName = userInfos.signature.replace("uploads/signature/", "");
          setselectedFiles({
            name: cleanName,
            preview: BACKEND_URL_PORTAIL + userInfos.signature,
          });
        }
       
        getIsUserBlocked();
        if (response.length > 0) {
          const options = response.map((org) => ({
            groupeName: org.groupeName,
            groupId: org.groupId,
            valid:true,
            quessRegistre: org.quessRegistre, 
            quessControle:org.quessControle,
            quessCompounent:org.quessCompounent
          }));
          setOrganization(options);
        }
  
        // Récupération des groupes non affectés avec `null`
        const response1 = await axios.get(
          `${BACKEND_URL_PORTAIL}api/getGroupNotAffectedPortail/` + null,
          config
        );
  
        if (response1.length > 0) {
          const options2 = response1.map((org) => ({
            groupeName: org.groupeName,
            groupId: org.groupId,
            valid:true,
            quessRegistre: org.quessRegistre, 
            quessControle:org.quessControle,
            quessCompounent:org.quessCompounent
          }));
          setOriginalOrganisations(options2);
        }
  
        // Récupération du statut 2FA
        const has2Fa = await axios.get(
          `${BACKEND_URL_PORTAIL}api/user/has2FA/` + userId,
          config
        );
  
        const groupsToAdd = [...groups, ...(response.length > 0 ? [response[0].groupId] : [])];
        if (userInfos.is_enabled === false) {
          setRestore(true);
        }
       
        if(userInfos.is_available==false)
          {
            setRaison([{
              value: "reason",
              label: t("reason"),
            },
            {
              value: "other",
              label: t("other"),
            }]
            )
          }

        setListOfGroups(groupsToAdd);
        setActifUser(userInfos.is_available)
        setFormData((prevFormData) => ({
          ...prevFormData,
          id: userInfos.id,
          email: userInfos.email,
          firstname: userInfos.firstname,
          lastname: userInfos.lastname,
          phone: userInfos.phone,
          phone2: userInfos.phone2,
          username: userInfos.username,
          signature: userInfos.signature,
          passwordChange: userInfos.password_change,
          isEnabled: userInfos.is_enabled,
          isAvailable: userInfos.is_enabled,
          listOfGroups: groups,
          has2Fa: has2Fa.hasDoubleAuth==202?true:false,
          listRoleOfGroup: [...registreRoles, ...controleRoles, ...compounentRoles]
          ,
        }));
        setCurrentReason(userInfos.is_available);
        setOriginalPassword("");
        setLoading(false);
        setLoadingPage(false);
      } catch (error) {
        setError("Failed to load organizations");
        setLoading(false);
        setLoadingPage(false);
      }
    };
  
    fetchOrganization();
  }, [userId]);
  
const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};
  function getRaisonAvailableUser(idUser) {
    const config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    axios
      .get(BACKEND_URL_PORTAIL+ "api/raisonsAvailableUser/" + idUser, config)
      .then((response) => {
        setListAvailableUser(response);
      });
  }
  function getIsUserBlocked() {
    const config = {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    };
    axios.get(BACKEND_URL_PORTAIL + 'api/isUserBlocked/' + userId, config).then(
      (res) => {
        if (res.isBlocked === 203) {
          setDisabledBlockedUser(true);
        } else {
          setDisabledBlockedUser(false);
        }
        setBlockedUser(res.isBlocked==203?false:true);
        setInitialUserBlockedStatus(res.isBlocked==203?false:true);
      }).catch(error => console.error(error));
  }

  const handleChangeReason = (selectedOption) => {
    if (selectedOption.value === "other") {
      setShowOther(true);
    } else {
      setShowOther(false);
    }
    if (selectedOption.value === "reason" && currentReason != actifUser) {
      setCheckReason(true);
    } else {
      setCheckReason(false);
    }
    setNewUser(selectedOption.value);
  };

  const handleChangeActifUser = () => {
    if (currentReason !=actifUser && newUser == "reason") {
      setCheckReason(true);
    } else {
      setCheckReason(false);
    } 
  };
  const handleChangeOther = (event) => {
    setOther(event.target.value);
  };
  
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };

  /* const addGroup = () => {
    const selectedGroup = organizations.find(
      (g) => g.groupId === parseInt(listOfGroup[listOfGroup.length-1])
    );
   
    if (
      selectedGroup &&
      !selectedGroups.find((g) => g.groupId === selectedGroup.groupId)
    ) {
      
      setSelectedGroups([...selectedGroups, selectedGroup]);
      setFormData({
        ...formData,
        listOfGroups: [...formData.listOfGroups, selectedGroup.groupId],
      });
      setOrganization(organizations.filter((g) => g !== selectedGroup));
      if( organizations.filter((g) => g !== selectedGroup).length>0)
      {
        setListOfGroups([
          ...(listOfGroup || []),
         
             organizations.filter((g) => g !== selectedGroup)[0].groupId
            
        ]);
      }
    }
  }; */
  


 const addGroup = () => {
    let selectedGroup = null;

  if (groupIdSelected === "") {
    selectedGroup = organizations.find(
      (g) => g.groupId === parseInt(organizations[0]?.groupId)
    );
  } else {
    selectedGroup = organizations.find(
      (g) => g.groupId === parseInt(groupIdSelected)
    );
    setGroupIdSelected("");
  }
  

  if (
    selectedGroup &&
    !selectedGroups.find((g) => g.groupId === selectedGroup.groupId)
  ) {
    // 🎯 rôle compounding par défaut (dernier, hors rôles additifs verificator / inventory)
    const primaryCompounentRoles =
      selectedGroup.quessCompounent?.filter(
        c => !ADDITIVE_COMPOUNDING_ROLES.includes(c.name)
      ) || [];
    const defaultRole = primaryCompounentRoles[primaryCompounentRoles.length - 1];

    /* =====================================================
       1️⃣ Préparer le groupe AVEC checked correct (UI)
    ====================================================== */
    const preparedGroup = {
      ...selectedGroup,
      quessCompounent: selectedGroup.quessCompounent.map(comp => ({
        ...comp,
        checked: defaultRole ? comp.id === defaultRole.id : false
      })),
      quessRegistre: selectedGroup.quessRegistre.map(r => ({
        ...r,
        checked: false
      })),
      quessControle: selectedGroup.quessControle.map(c => ({
        ...c,
        checked: false
      }))
    };

    /* =====================================================
       2️⃣ Ajouter le groupe à l’UI
    ====================================================== */
    setSelectedGroups(prev => [...prev, preparedGroup]);

    /* =====================================================
       3️⃣ Ajouter le rôle par défaut (SOURCE MÉTIER)
    ====================================================== */
    if (defaultRole) {
      setListRoleOfGroup(prev => [
        ...prev,
        {
          groupId: selectedGroup.groupId,
          itemId: defaultRole.id,
        },
      ]);
    }

    /* =====================================================
       4️⃣ FormData + listes
    ====================================================== */
    setFormData(prev => ({
      ...prev,
      listOfGroups: [...prev.listOfGroups, selectedGroup.groupId],
    }));

    setOrganization(organizations.filter(g => g !== selectedGroup));

    setListOfGroups((prev) => [
  ...(prev || []),
  selectedGroup.groupId,
]);
  }
};
  /* const removeGroup = (listOfGroupId) => {
    const selectedGroup = originalOrganizations.find(
      (g) => g.groupId === listOfGroupId
    );
   
    setSelectedGroups(selectedGroups.filter((g) => g.groupId !== listOfGroupId));
    setListRoleOfGroup(prev =>
    prev.filter(role => role.groupId !== listOfGroupId)
    );
    setOrganization([...organizations, selectedGroup]);
  }; */
  
  const removeGroup = (listOfGroupId) => {

     const selectedGroup = selectedGroups.find(
      (g) => g.groupId === listOfGroupId
    );
  // 1️⃣ state listOfGroup
  setListOfGroups(prev =>
    prev.filter(g => g !== listOfGroupId));

  // 2️⃣ formData.listOfGroups
   setFormData(prev => ({
    ...prev,
    listOfGroups: prev.listOfGroups.filter(
      g => g !== listOfGroupId
    ),
  }));

  // 3️⃣ selectedGroups
  setSelectedGroups(prev =>
    prev.filter(g => g.groupId !== listOfGroupId)
  );

  // 4️⃣ listRoleOfGroup
  setListRoleOfGroup(prev =>
    prev.filter(role => role.groupId !== listOfGroupId)
  );

  setOrganization([...organizations, selectedGroup]);
};
console.log(selectedGroups)
console.log(formData)
console.log(listOfGroup)
console.log(organizations)

  function handleAcceptedFiles(files) {
    files.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    );

    // Store only the first file (for single file upload)
    setChangedSignature(true);
    setselectedFiles(files[0]);
  }

  /**
   * Formats the size
   */
  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }
  const navigate = useNavigate();

  const calculatePasswordStrength = (password) => {
    let strength = 0;
    let text = t("veryWeak");
    let color = "dark";

    // Check length
    const isLongEnough = password.length >= 4;

    if (!isLongEnough) {
      // If password is too short
      setPasswordStrength({ value: 0, text: t("veryWeak"), color: "dark" });
      return;
    }

    // Criteria checks
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasDigit = /\d/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

    const criteriaCount = [
      hasUpperCase,
      hasLowerCase,
      hasDigit,
      hasSpecialChar,
    ].filter(Boolean).length;

    switch (criteriaCount) {
      case 4:
        strength = 100;
        text = t("strong");
        color = "success";
        break;
      case 3:
        strength = 75;
        text = t("good");
        color = "info";
        break;
      case 2:
        strength = 50;
        text = t("fair");
        color = "warning";
        break;
      case 1:
        strength = 25;
        text = t("weak");
        color = "danger";
        break;
      default:
        strength = 0;
        text = t("veryWeak");
        color = "light";
    }

    setPasswordStrength({ value: strength, text, color });
  };
  useEffect(() => {
    calculatePasswordStrength(formData.password);
    checkPasswordMatch(formData.password, formData.passwordConfirmation);
  }, [formData.password, formData.passwordConfirmation]);

  const handlePasswordConfirmationChange = (e) => {
    setFormData({ ...formData, passwordConfirmation: e.target.value });
  };
  const handlePasswordChange = (e) => {
    const password = e.target.value;
    setFormData({ ...formData, password });
    calculatePasswordStrength(password);
  };
   /* const handleChangeGroupRole = (groupId, roleId) => {
    // Find the group-role pair that matches the passed groupId and roleId
    const groupRole = listRoleOfGroup.find(
      (el) => el.groupId === groupId && el.itemId === roleId
    );
   
    if (groupRole) {
      // Remove the group-role pair if it exists
      const updatedListRoleOfGroup = listRoleOfGroup.filter(
        (el) => !(el.groupId === groupId && el.itemId === roleId)
      );
      setListRoleOfGroup(updatedListRoleOfGroup);
    } else {
      // Add the new group-role pair if it doesn't exist
      setListRoleOfGroup([...listRoleOfGroup, { groupId, itemId: roleId }]);
    }
    const updatedGroups = selectedGroups.map((group) => {
      if (group.id == groupId) {
        // Update the specific group
        return {
          ...group,
          roles: group.roles.map((role) => {
            if (role.id == roleId) {
              // Update the specific role
              return {
                ...role,
                checked: !role.checked, // Toggle the checked state
              };
            }
            return role; // Keep other roles unchanged
          }),
        };
      }
      return group; // Keep other groups unchanged
    });

    // Now you can set the updated groups
    setSelectedGroups(updatedGroups);
  };  */

 /*  const handleChangeGroupRole = (groupId, roleId) => {
    console.log("groupId: ",groupId)
    console.log("roleId ",roleId)
    // Vérification si l'élément existe déjà dans listRoleOfGroup
    const groupRole = listRoleOfGroup.find(
      (el) => el.groupId === groupId && el.itemId === roleId
    );
  
    // Mise à jour de listRoleOfGroup
    if (groupRole) {
      const updatedListRoleOfGroup = listRoleOfGroup.filter(
        (el) => !(el.groupId === groupId && el.itemId === roleId)
      );
      setListRoleOfGroup(updatedListRoleOfGroup);
    } else {
      setListRoleOfGroup([...listRoleOfGroup, { groupId, itemId: roleId }]);
    }
  
    // Mise à jour de selectedGroups
    const updatedGroups = selectedGroups.map((group) => {
      if (group.groupId == groupId) {
        const isCompounent = group.quessCompounent.some(c => c.id === roleId);
        return {
          ...group,
          quessRegistre: group.quessRegistre.map((registre) => {
            if (registre.id == roleId) {
              return {
                ...registre,
                checked: !registre.checked, // Inverse le checked
              };
            }
            return registre;
          }),
          quessControle: group.quessControle.map((controle) => {
            if (controle.id == roleId) {
              return {
                ...controle,
                checked: !controle.checked, // Inverse le checked
              };
            }
            return controle;
          }),
          quessCompounent: isCompounent
          ? group.quessCompounent.map((compounent) => ({
              ...compounent,
              checked: compounent.id === roleId // un seul élément coché
            }))
          : group.quessCompounent, // inchangé si ce n’est pas un composant
        };
      }
      return group;
    });
  
    setSelectedGroups(updatedGroups);
  }; */

const handleChangeGroupRole = (groupId, roleId) => {
  // 🔎 Récupérer le groupe courant
  const currentGroup = selectedGroups.find(
    g => g.groupId === groupId
  );

  if (!currentGroup) return;

  // 🔎 Les rôles "verificator" et "inventory" sont additifs : ils ne font pas partie
  // du groupe à sélection unique et se cumulent avec le rôle principal.
  const isAdditiveRole = ADDITIVE_COMPOUNDING_ROLES.includes(
    currentGroup.quessCompounent?.find(c => c.id === roleId)?.name
  );

  // 🔎 IDs des compounding du groupe (hors rôles additifs)
  const compoundingIds =
    currentGroup.quessCompounent
      ?.filter(c => !ADDITIVE_COMPOUNDING_ROLES.includes(c.name))
      .map(c => c.id) || [];

  const isCompounding = compoundingIds.includes(roleId);

  /* =====================================================
     1️⃣ MISE À JOUR DE listRoleOfGroup (SOURCE MÉTIER)
  ====================================================== */
  setListRoleOfGroup(prev => {
    const exists = prev.some(
      el => el.groupId === groupId && el.itemId === roleId
    );

    // 🔁 Toggle normal (registre / controle)
    if (!isCompounding) {
      if (exists) {
        return prev.filter(
          el => !(el.groupId === groupId && el.itemId === roleId)
        );
      }
      return [...prev, { groupId, itemId: roleId }];
    }

    // 🔒 CAS COMPUNDING → UN SEUL AUTORISÉ
    let cleaned = prev.filter(
      el =>
        el.groupId !== groupId ||
        !compoundingIds.includes(el.itemId)
    );

    return [...cleaned, { groupId, itemId: roleId }];
  });

  /* =====================================================
     2️⃣ MISE À JOUR DE selectedGroups (UI)
  ====================================================== */
  const updatedGroups = selectedGroups.map(group => {
    if (group.groupId !== groupId) return group;

    return {
      ...group,

      // ✅ Registres → multi
      quessRegistre: group.quessRegistre.map(registre =>
        registre.id === roleId
          ? { ...registre, checked: !registre.checked }
          : registre
      ),

      // ✅ Controle → multi
      quessControle: group.quessControle.map(controle =>
        controle.id === roleId
          ? { ...controle, checked: !controle.checked }
          : controle
      ),

      // 🔓 Verificator / Inventory → additifs (indépendants du rôle principal)
      // 🔒 Autres compounding (admin/adminClient/preparer) → un seul
      quessCompounent: group.quessCompounent.map(comp => {
        if (isAdditiveRole) {
          return comp.id === roleId ? { ...comp, checked: !comp.checked } : comp;
        }
        if (isCompounding) {
          return ADDITIVE_COMPOUNDING_ROLES.includes(comp.name)
            ? comp
            : { ...comp, checked: comp.id === roleId };
        }
        return comp;
      })
    };
  });

  setSelectedGroups(updatedGroups);
};


  function sanitizeFileName(originalFileName) {
    return originalFileName.replace(/\//g, " "); // Replace all slashes with a blank space
  }
  const checkUserName = () => {
    if (formData.username == "") {
      setUserNameError(true);
      return false;
    } else {
      setUserNameError(null);
      return true;
    }
  };

  const checkUserNameExists = async (username)=>{
    const userExists = await axios.get(
      `${BACKEND_URL_PORTAIL}api/user/check/`+
      username+`/`+userId,
      config
    );
      return userExists.exists
  }
  const checkEmailExists = async (email)=>{
    const userExists = await axios.get(
      `${BACKEND_URL_PORTAIL}api/user/checkEmailExist/`+
      email+`/`+userId,
      config
    );
      return userExists.exists
  }
  const checkUserNameInDb=async ()=> {
  const  exists= await checkUserNameExists(formData.username,formData.id)

    if(exists)
    {
      setUserNameExistsError(true)
      return exists
    }
    else {
      setUserNameExistsError(null)
      return exists
    }
      
  }
  const checkSelectedGroups = () => {
    if (selectedGroups.length == 0) {
      setSelectedGroupsError(true);
      return false;
    } else {
      setSelectedGroupsError(null);
      return true;
    }
  };
  const checkEmailInDb=async ()=> {
   if(formData.email!='')
   {
    const  exists= await checkEmailExists(formData.email,formData.id)
   
    if(exists)
    {
      setEmailExistsError(true)
      return exists
    }
    else {
      setEmailExistsError(null)
      return exists
    }
   }
   else {
    return false;
   }
    
        
    }
  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic regex for email validation
    return re.test(email);
  };

  const checkPassword = () => {
    if(!passwordChange)
    {
      return true;
    }
    if (formData.password == "") {
      setPasswordError(true);
      return false;
    } else {
      setPasswordError(null);
      return true;
    }
  };
  const checkFirstName = () => {
    if (formData.firstname == "") {
      setFirstNameError(true);
      return false;
    } else {
      setFirstNameError(null);
      return true;
    }
  };
  const checkLastName = () => {
    if (formData.lastname == "") {
      setLastNameError(true);
      return false;
    } else {
      setLastNameError(null);
      return true;
    }
  };
  /* const checkPhone = () => {
    if (formData.phone == "") {
      setPhoneError(true);
      return false;
    } else {
      setPhoneError(null);
      return true;
    }
  }; */
  const checkEmail = () => {
    if (formData.email == "") {
      setEmailError(true);
      return false;
    } else {
      setEmailError(null);
      return true;
    }
  };
  const checkValidEmail = () => {
    if (formData.email == "") {
      setValidEmailError(null);
      return true;
    } else if (!validateEmail(formData.email)) {
      setValidEmailError(true);
      return false;
    } else {
      setValidEmailError(null);
      return true;
    }
  };
  function removePartOfString(str) {
    // Trouver l'index de la sous-chaîne à supprimer
    const index = str.indexOf(".bce");

    // Si la sous-chaîne existe, retourner la partie avant l'index trouvé
    if (index !== -1) {
      return str.substring(0, index);
    }

    // Si la sous-chaîne n'existe pas, retourner la chaîne originale
    return str;
  }
  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    const isUserNameValid = checkUserName();
    const isFirstNameValid = checkFirstName();
    const isLastNameValid = checkLastName();
    const isPasswordValid = checkPassword();
    const isEmailValid = checkEmail();
    /* const isPhoneValid = checkPhone(); */
    const isEmailFormatValid = checkValidEmail();
    const isPasswordMatch = passwordMatch === true;
    const emailExistsInDb= isEmailValid?await  checkEmailInDb():true;
    const groupsNotEmpty = checkSelectedGroups();
    const userNameExistsInDb=await  checkUserNameInDb()

    if (
      !isUserNameValid ||
      !isFirstNameValid ||
      !isLastNameValid ||
      !isPasswordValid ||
      !isEmailValid ||
      /* !isPhoneValid || */
      !isEmailFormatValid ||
      !isPasswordMatch ||
      userNameExistsInDb ||
      !groupsNotEmpty ||
      emailExistsInDb
    ) {
      setUserAddedMessage({ text: t("failureUpdateUser"), type: "error" });
      setTimeout(() => {
        setUserAddedMessage(null);
        setLoading(null);
      }, 2500);
    } else {
      const userData = {
        id: formData.id,
        app:"portail",
        username: formData.isAvailable ? removePartOfString(formData.username) : formData.username,
        lastname: formData.lastname,
        firstname: formData.firstname,
        password: formData.password,
        email: formData.email,
        phone: formData.phone,
        phone2: formData.phone2 || "",
        isEnabled: formData.isAvailable,
        isAvailable: actifUser,
        reason: newUser,
        other: other,
        passwordChange: formData.passwordChange,
        listOfGroup: formData.listOfGroups.filter((group) => group !== ""),
        listRoleOfGroup: listRoleOfGroup, // Pas besoin de JSON.stringify
        filesNames: selectedFiles ? sanitizeFileName(selectedFiles.name) : "",
        language: formData.language,
        currentOrg: formData.currentOrg,
        signature: formData.signature ? formData.signature : null, // Gérer les fichiers si besoin
      };
      const configUpload = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "multipart/form-data",
        },
      };
      const data2FAUser = {
        userId: userId,
        hasDoubleAuth: formData.has2Fa,
      }
      try {
        const response = await axios.post(
          `${BACKEND_URL_PORTAIL}api/saveUser`,
          userData,
          config
        );
        setIsClicked(true);
        if (changedSignature) {
         let promises = [];
         if(selectedFiles){
         
                   const data = new FormData();
                   data.append("File", selectedFiles);
                   data.append("fileName", selectedFiles.name);
                   promises.push(
                     axios
                       .post(BACKEND_URL_PORTAIL + "api/saveSignFile", data, configUpload)
                       .then((res) => {})
                   );
                  
         }
                  
        }
        if (blockedUser === false && initialUserBlockedStatus == true) {
            axios.post(BACKEND_URL_PORTAIL + 'api/unblockUser', { idUser: userId }, config).then((res) => { });
          }
        axios
        .post(BACKEND_URL_PORTAIL + "api/update2FAUser", data2FAUser, config)
        .then((res) => {});
        setLoading(false);
        
        if (response.status === 'success') {
          setUserAddedMessage({
            text: t("successUpdateUser"),
            type: "success",
          });
          setTimeout(() => {
            setUserAddedMessage(null);
            setLoading(null);
            navigate("/users-management");
            window.location.reload();
          }, 2500);
        } else {
          setIsClicked(false);
          setUserAddedMessage({ text: t("failureUpdateUser"), type: "error" });
          setTimeout(() => {
            setUserAddedMessage(null);
            setLoading(null);
          }, 2500);
        }
       
      } catch (error) {
        setLoading(false);
        console.error("Error saving user:", error);
      }
    }
  };
  const checkPasswordMatch = (password, passwordConfirmation) => {
    if(password!="")
    {
      setPasswordMatch(password === passwordConfirmation);

    }
  };

  const goBack = () => {
    const source= localStorage.getItem('source');
    if(source==="listUsers")
    {
      navigate("/users-management"); // Redirect after successful creation
    }
    else {
      navigate("/update-group/"+localStorage.getItem('groupId')); 
      localStorage.removeItem('groupId')
    }
    localStorage.removeItem('source')
  };
  const cancelPasswordChange = () => {
    setPasswordChange(!passwordChange);
    setFormData((prevFormData) => ({
      ...prevFormData, // Spread the previous form data
      password: originalPassword, // Update the password field
    }));
  };

  const handlePhoneInput = (value) => {
    // Remove all non-digit characters
    const cleaned = value.replace(/\D/g, "").slice(0, 10); // Limit to 10 digits
  
    // Format the input as (XXX) XXX-XXXX
    const formatted = cleaned
      .replace(/^(\d{3})(\d{0,3})(\d{0,4})$/, (_, p1, p2, p3) => {
        let result = `(${p1}`;
        if (p2) result += `) ${p2}`;
        if (p3) result += `-${p3}`;
        return result;
      });
  
    // Update formData with the formatted phone number
    setFormData({ ...formData, phone: formatted });
  };

  const handlePhone2Input = (value) => {
    const cleaned = value.replace(/\D/g, "").slice(0, 10);
    setFormData({ ...formData, phone2: cleaned });
  };
  return (
    <React.Fragment>
      <div className="page-content">
      {loadingPage && <div className="text-center mt-3">
                        <Spinner
                       color="primary"
                       style={{
                         height: '3rem',
                         width: '3rem'
                       }}
                     >
                       Loading...
                        </Spinner>
                        <div className="text-center mt-3">
                      {t("loading...")}
                      </div>
                      </div>}

      {!loadingPage && (
        <Container  style={{marginTop:"1%"}} fluid={true}>
           <Card className="card-bordred custom-card">
<Breadcrumbs title={t("user")} breadcrumbItem={t("updateUser")} />
          {loading ? (  <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100vw",
                  height: "100vh",
                  backgroundColor: "rgba(0,0,0,0.4)", // gray overlay
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: 9999
                }}
              >
                <Spinner
                  color="primary"
                  style={{
                    height: "3rem",
                    width: "3rem"
                  }}
                >
                  {t("loadingSubmission")}
                </Spinner>
              </div>
          ) : error ? (
            <Alert color="danger">{error}</Alert>
          ) : null}
          <div className=" mb-4">
            <div
              style={{
                margin: "1%",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              
            </div>
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col lg={12}>
                  <Card className="card-bordred">
                  <div className="card-header custom-header">
                    <button
                      className="btn btn-primary"
                      title={t("goBack")}
                      onClick={() => goBack()}
                    >
                      <i className="fas fa-arrow-left"></i>
                    </button>
                    </div>
                    <CardBody>
                      {restore && (
                              <>
                                
                                  <Row className="mt-3">
                                    <Col lg={4}>
                                      <label className="form-label">{t("restore")}</label>
                                    </Col>
                                    <Col lg={4}>
                                      <input
                                        type="checkbox"
                                        checked={formData.isAvailable}
                                        onClick={(e) =>
                                          setFormData({
                                            ...formData,
                                            isAvailable: !formData.isAvailable,
                                          })
                                        }
                                        className="btnCheckbox"
                                      />
                                    </Col>
                                  </Row>
                                
                                <hr /> {/* Remplace Divider de MUI par hr de Bootstrap */}
                              </>
                            )}
                      <Card className="card-bordred">
                        <CardBody className="paperGroupStyle">
                          <Row className="mt-3">
                            <Col lg={2} >
                              <label className="form-label">{t("UserBlocked")}</label>
                            </Col>
                            <Col lg={10} >
                              <div className="unlockuserDiv">
                                <button
                                
                                  className="blockedUserCss"
                                  onClick={() => {
                                      setBlockedUser(!blockedUser);
                                      if (blockedUser === false) {
                                        setDisabledBlockedUser(true);
                                      }
                                    }}
                                  disabled={!blockedUser}
                                  style={{
                                    height: "43px",
                                    backgroundColor: blockedUser ? "#fb1616" : "white",
                                    color: blockedUser ? "#eaf1f9" : "rgb(143 146 148)",
                                    padding: "8px 8px",
                                    border: "1px solid rgb(143 146 148)",
                                    borderRadius: "20px",
                                    cursor: blockedUser ? "pointer" : "not-allowed",
                                    fontSize: "18px",
                                  }}
                                >
                                  {t("unlockuser")}
                                </button>
                                {blockedUser && (
                                  <p className="InblockMessage">
                                    ⚠️ {t("InblockMessage")}
                                  </p>
                                )}
                              </div>
                            </Col>
                          </Row>

                          <Row className="mt-3">
                            <Col lg={2}>
                            <label className="form-label">{t("username")}</label>
                            </Col>
                            <Col lg={10}>
                              
                              <input
                                name="username"
                                className="form-control"
                                type="text" 
                                placeholder={t("username")}
                                value={formData.username}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    username: e.target.value,
                                  })
                                }
                                disabled={restore}
                              />
                              {userNameError && (
                                <code className="text-danger">
                                  {" "}
                                  {t("userNameRequiredMessage")}
                                </code>
                                
                              )}
                              {userNameExistsError && (
                                <code className="text-danger">
                                  {" "}
                                  {t("userNameExistsMessage")}
                                </code>
                              )}
                            </Col>
                          </Row>
                          <Row className="mt-3">
                            <Col lg={2}>
                            <label className="form-label">{t("firstName")}</label>
                            </Col>
                            <Col lg={10}>
                            
                              <input
                                name="firstname"
                                className="form-control"
                                type="text"
                                placeholder={t("firstName")}
                                value={formData.firstname}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    firstname: e.target.value,
                                  })
                                }
                                disabled={restore}
                              />
                              {firstNameError && (
                                <code className="text-danger">
                                  {" "}
                                  {t("firstNameRequired")}
                                </code>
                              )}
                            </Col>
                          </Row>
                          <Row className="mt-3">
                            <Col lg={2}>
                            <label className="form-label">{t("lastName")}</label>
                            </Col>
                            <Col lg={10}>
                            
                              <input
                                name="lastname"
                                className="form-control"
                                type="text"
                                placeholder={t("lastName")}
                                value={formData.lastname}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    lastname: e.target.value,
                                  })
                                }
                                disabled={restore}
                              />
                              {lastNameEroor && (
                                <code className="text-danger">
                                  {" "}
                                  {t("lastNameRequired")}
                                </code>
                              )}
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>  

                      <Card className="card-bordred">
                      <CardBody className="paperGroupStyleContact">
                      {passwordChange && (
                        <div>
                          <Row className="mt-3 ">
                          <Col lg={2}></Col>
                            <Col lg={10}>
                              <button
                                className="ms-1 btn btn-primary me-3"
                                onClick={() => cancelPasswordChange()}
                              >
                                {t("cancelChangePassword")}
                              </button>
                            </Col>
                          </Row>
                          <Row className="mt-3">
                            <Col lg={2}>
                            <label className="form-label">
                                {t("password")}
                              </label>
                            </Col>
                            <Col lg={9}>
                              <input
                                name="password"
                                placeholder={t("password")}
                                className="form-control"
                                type={showPassword ? "text" : "password"}
                                value={formData.password}
                                onChange={handlePasswordChange}
                                
                              />
                              <span 
                              className="password-toggle" 
                              onClick={() => setShowPassword(!showPassword)}
                              style={{ position: 'absolute', right: '20px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer' }}
                            >
                              {showPassword ? (
                                <i className="fas fa-eye-slash"></i>
                              ) : (
                                <i className="fas fa-eye"></i>
                              )}
                            </span>
                              
                            </Col>
                          </Row>
                          <Row className="mt-3">
                                                      <Col lg={2}></Col>
                                                      <Col lg={9}>
                                                      {passwordError && (
                                                            <code className="text-danger">
                                                              {" "}
                                                              {t("passwordRequiredMessage")}
                                                            </code>
                                                          )}</Col>
                                                      </Row>
                          <Row className="mt-3">
                          <Col lg={2}></Col>
                          <Col lg={passwordMatch?3: 4}>
                              <div
                                className={`progress-label text-${passwordStrength.color} border-${passwordStrength.color} mb-2`}
                              >
                                {passwordStrength.text}
                              </div>
                              <Progress
                                striped
                                color={passwordStrength.color}
                                value={passwordStrength.value}
                                id="strongpassword"
                              />
                            </Col>
                          </Row>
                          <Row className="mt-3">
                            <Col lg={2}>
                            <label className="form-label">
                                {t("passwordConfirm")}
                              </label>
                            </Col>
                            <Col lg={9}>
                              <input
                                name="passwordConfirmation"
                                placeholder={t("passwordConfirm")}
                                className="form-control"
                                type={showPasswordConfirm ? "text" : "password"}
                                value={formData.passwordConfirmation}
                                onChange={handlePasswordConfirmationChange}
                              />
                              <span 
                              className="password-toggle" 
                              onClick={() => setShowPasswordConfirm(!showPasswordConfirm)}
                              style={{ position: 'absolute', right: '20px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer' }}
                            >
                              {showPasswordConfirm ? (
                                <i className="fas fa-eye-slash"></i>
                              ) : (
                                <i className="fas fa-eye"></i>
                              )}
                            </span>
                             
                            </Col>
                            <Col lg={passwordMatch?1:0}>
                                { formData.password!=""&&formData.passwordConfirmation!=""&&passwordMatch &&<span class="mdi mdi-checkbox-marked-circle-outline" style={{fontSize:"28px",color:"green"}}></span>}

                            </Col>
                          </Row>  
                          <Row className="mt-3">
                                                      <Col lg={2}></Col>
                                                      <Col lg={9}>
                                                      {formData.password!=""&&formData.passwordConfirmation!=""&&!passwordMatch && (
                                                            <code className="text-danger">
                                                              {" "}
                                                              {t("passwordDontMatch")}
                                                            </code>
                                                          )}</Col>
                                                      </Row>                       
                        </div>
                      )}
                        {!passwordChange && (
                          <div>
                          <Row className="mt-3 justify-content-center">
                          <Col lg={2}></Col>
                            <Col lg={10}>
                              <button
                                className="ms-1 btn btn-primary me-3"
                                onClick={() => setPasswordChange(!passwordChange)}
                                disabled={restore}
                              >
                                {t("changePassword")}
                              </button>
                            </Col>
                          </Row>
                          </div>
                        )}
                    </CardBody>
                    </Card>

                    <Card className="card-bordred">
                      <CardBody className="paperGroupStyle">
                        <Row className="mt-3">
                          <Col lg={2}>
                          <label className="form-label">{t("email")}</label>
                          </Col>
                          <Col lg={10}>
                            <input
                              name="email"
                              className="form-control"
                              type="email"
                              placeholder={t("email")}
                              value={formData.email}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  email: e.target.value,
                                })
                              }
                              disabled={restore}
                            />
                            {emailError && (
                              <code className="text-danger">
                                {" "}
                                {t("emailRequired")}
                              </code>
                            )}
                            {validEmailError && (
                              <code className="text-danger">
                                {" "}
                                {t("errorEmail")}
                              </code>
                            )}
                            {emailExistsError && (
                              <code className="text-danger">
                                {" "}
                                {t("emailExistsErrorMessage")}
                              </code>
                            )}
                          </Col>
                        </Row>
                        <Row className="mt-3">
                          <Col lg={2}>
                            <label className="form-label">{t("phone")}</label>
                          </Col>
                          <Col lg={10}>
                            <input
                                  name="phone"
                                  className="form-control"
                                  type="text" // Use text instead of number for formatting
                                  placeholder={"(123) 456-7899"} // e.g., "Enter phone number"
                                  value={formData.phone}
                                  onChange={(e) => handlePhoneInput(e.target.value)}
                                  disabled={restore}
                                />
                            {/* {phoneError && (
                              <code className="text-danger">
                                {" "}
                                {t("phoneRequired")}
                              </code>
                            )} */}
                          </Col>
                        </Row>
                        <Row className="mt-3">
                          <Col lg={2}>
                            <label className="form-label">{t("phone2")}</label>
                          </Col>
                          <Col lg={10}>
                            <input
                                  name="phone2"
                                  className="form-control"
                                  type="text" // Use text instead of number for formatting
                                  placeholder={t("phone2")} // e.g., "Enter phone number"
                                  value={formData.phone2}
                                  onChange={(e) => handlePhone2Input(e.target.value)}
                                  disabled={restore}
                                />
                          
                          </Col>
                        </Row>
                        <Row className="mt-3">
                          <Col lg={2}>
                          <label className="form-label">
                                {t("activateMFA")}
                              </label>
                          </Col>
                        <Col lg={10}>
                            <div className="form-check">
                              <input
                                name="activateMFA"
                                className="form-check-input"
                                type="checkbox"
                                checked={formData.has2Fa}
                                onClick={() =>
                                  setFormData({
                                    ...formData,
                                    has2Fa: !formData.has2Fa,
                                  })
                                }
                                disabled={restore}
                              />
                            
                            </div>
                          </Col>
                        </Row>
                        {/* Signature Upload */}
                        <Row className="mt-3">
                          <Col lg={6}>
                          <label className="form-label">{t("signature")}</label>
                          </Col>
                          <Col lg={6}>                         
                                <Form className="dropzone" style={{cursor:"pointer"}}>
                                  <Dropzone
                                    onDrop={(acceptedFiles) =>
                                      handleAcceptedFiles(acceptedFiles)
                                    }
                                    accept={{
                                      "image/*": [],
                                    }}
                                    maxFiles={1}
                                  >
                                    {({ getRootProps, getInputProps }) => (
                                      <div className="dropzone">
                                        <div style={{ textAlign: "center",cursor:"pointer" }}>
                                          <div
                                            className="dz-message needsclick"
                                            {...getRootProps()}
                                          >
                                            <input {...getInputProps()} />
                                            <div className="mb-3 ">
                                              <i className="display-4 text-muted ri-upload-cloud-2-line"></i>
                                            </div>
                                            <h4> {t("uloadFiles")}</h4>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </Dropzone>
                                  {selectedFiles && (
                                    <div className="mt-3 text-center">
                                      <img
                                        src={selectedFiles.preview}
                                        alt={selectedFiles.name}
                                        style={{
                                          maxWidth: "100%",
                                          height: "auto",
                                        }}
                                      />
                                      <ul className="list-group mt-3">
                                        <li className="list-group-item d-flex justify-content-between align-items-center">
                                          {selectedFiles.name}
                                          <button
                                            className="btn btn-danger btn-sm"
                                            onClick={() => handleRemoveFile()}
                                          >
                                            {t("delete")}
                                          </button>
                                        </li>
                                      </ul>
                                    </div>
                                  )}
                                </Form>
                          </Col>
                        </Row>

                      </CardBody>
                    </Card>
                    <Card className="card-bordred">
                      <CardBody className="paperGroupStyle">
                        {  userId !== localStorage.getItem("idUser") &&(
                        <Row className="mt-3">
                          <Col lg={2}>
                          <label className="form-label">
                                {t("activateAccess")}
                              </label></Col>
                        
                          <Col lg={1}>
                          
                          <input
                              type="checkbox"
                              checked={actifUser}
                              onClick={() => {setActifUser(!actifUser)}}
                              disabled={restore}
                            className="btnCheckbox"
                            />
                              
                            
                          </Col>
                          
                          <Col lg={3}>
                            <Select
                                value={raison.find(option => option.value === newUser)} // Correspondance avec l'option sélectionnée
                                onChange={handleChangeReason}
                                options={raison}
                                disabled={restore}
                              />
                            {checkreason ? (
                                <p style={{ color: "red", fontSize: "0.7em" }}>
                                  {" "}
                                  {t("putReason")}
                                </p>
                              ) : null}
                          </Col>

                          {/* Input 'Other' */}
                          <Col lg={3}>
                            {showOther && (
                              <input
                                type="text"
                                className="form-control AdduserInput"
                                placeholder={t("specify")}
                                value={other}
                                onChange={handleChangeOther}
                                ref={otherInputRef}
                              />
                            )}
                          </Col>
                        </Row>)}
                        {listAvailableUser.length > 0 ? ( 
                        <Row className="mt-3">
                          <Col lg={2}>
                          <label className="form-label">
                                {t("ActivationLog")}
                              </label>
                          </Col>
                          <Col lg={10}>
                          <div className="reasonTableReason">
                              <table className="borders myTableStyle">
                                <tr className="headerStyle">
                                  <th className="no-wrap">{t("status")}</th>
                                  <th className="no-wrap">
                                    {t("administrateur")}
                                  </th>
                                  <th className="no-wrap">{t("DateActivite")}</th>
                                  <th className="no-wrap">{t("reason")}</th>
                                </tr>

                                {listAvailableUser.map((user, index) => (
                                  <tr key={index}>
                                    <td className="no-wrap cellPadding borders">
                                      {user.status ? t("actif") : t("inactif")}
                                    </td>
                                    <td className="no-wrap cellPadding borders">
                                      {user.adminUser.username}
                                    </td>
                                    <td className="no-wrap cellPadding borders">
                                      {moment
                                        .unix(user.timeStamp)
                                        .format("YYYY/MM/DD hh:mm A")}
                                    </td>
                                    <td className="no-wrap cellPadding borders">
                                      {user.reason ? t(user.reason) : "----"}
                                    </td>
                                  </tr>
                                ))}
                              </table>
                            </div>
                          </Col>
                          </Row>):null}

                        </CardBody>
                    </Card>
                      <Card className="card-bordred">
                    <CardBody className="paperGroupStyle">
                      {organizations.length > 0 ? ( 
                          <Row className="mt-3">
                            <Col lg={3}>
                              
                                {selectedGroups.length === 0 ? (
                                  <label className="form-label text-danger">
                                    {t("addGroup")}
                                  </label>
                                ) : (
                                  <label className="form-label">
                                    {t("addAnotherGroup")}
                                  </label>
                                )}
                              
                            </Col>
                            <Col lg={6}>
                              <select
                                className="form-select"
                                name="listOfGroup"
                                onChange={(e) => setGroupIdSelected(e.target.value)}
                                disabled={restore}
                              >
                                <option
                                  aria-selected="true"
                                  role="option"
                                  value="0"
                                  disabled
                                >
                                  {t("selectGroup")}
                                </option>
                                {organizations.map((listOfGroup) => (
                                  <option
                                    key={listOfGroup.groupId}
                                    value={listOfGroup.groupId}
                                  >
                                    {listOfGroup.groupeName}
                                  </option>
                                ))}
                              </select>
                              {selectedGroupsError && (
                                <code className="text-danger">
                                  {" "}
                                  {t("addGroup")}
                                </code>
                              )}
                            </Col>
                            <Col lg={3}>
                              <div className="form-check text-center">
                                <button
                                  className="btn btn-outline-info waves-effect waves-light"
                                  style={{ borderRadius: "50%" }}
                                  type="button"
                                  onClick={addGroup}
                                >
                                  <i className="fa fa-plus" />
                                </button>
                              </div>
                            </Col>
                          </Row>
                          ) : (
                            <Row className="mt-3"></Row>
                          )}

                            {selectedGroups.map((selectedGroup) => (
                              <Row className="mt-3 row-form" id={`listOfGroupId-${selectedGroup.groupId}`} key={selectedGroup.groupId}>
                                <Col lg={3}>
                                  <div className="form-check form-check-end">
                                    <label className="form-label">
                                      {selectedGroup.groupeName}
                                    </label>
                                  </div>
                                </Col>
                                <Col lg={6}>
                                {selectedGroup?.quessRegistre && selectedGroup.quessRegistre.length > 0 && (
                                  <label className="form-check-label text-succes mt-3 mb-2">
                                    {t('QUESSREGISTRES')}
                                  </label>
                                   )}
                                  {/* Affichage de quessRegistre */}
                                  {selectedGroup.quessRegistre &&
                                    selectedGroup.quessRegistre.map((registre) => (
                                      <div className="form-check form-check" key={registre.id}>
                                        <input
                                          value={registre.id}
                                          className="form-check-input"
                                          type="checkbox"
                                          id={`inlineCheck-registre-${registre.id}`}
                                          checked={registre.checked}
                                          onClick={() => handleChangeGroupRole(selectedGroup.groupId, registre.id)}
                                          disabled={restore||!selectedGroup.valid}
                                        />
                                        <label className="form-label" >
                                          {t(registre.name)}
                                        </label>
                                      </div>
                                    ))}
                                    <br />
                                  
                                  {selectedGroup?.quessControle && selectedGroup.quessControle.length > 0 && (
                                    <label className="form-check-label text-succes mt-3 mb-2">
                                              {t('QUESSCONTRÔLE')}
                                    </label>
                                  )}
                                  {/* Affichage de quessControle */}
                                  {selectedGroup.quessControle &&
                                    selectedGroup.quessControle.map((controle) => (
                                      <div className="form-check form-check" key={controle.id}>
                                        <input
                                          value={controle.id}
                                          className="form-check-input"
                                          type="checkbox"
                                          id={`inlineCheck-controle-${controle.id}`}
                                          checked={controle.checked}
                                          onClick={() => handleChangeGroupRole(selectedGroup.groupId, controle.id)}
                                          disabled={restore||!selectedGroup.valid}
                                        />
                                        <label className="form-label" >
                                          {t(controle.name)}
                                        </label>
                                      </div>
                                    ))}
                                   {selectedGroup?.quessCompounent && selectedGroup.quessCompounent.length > 0 && (
                                      <label className="form-check-label text-succes mt-3 mb-2">
                                        {t('QUESSCOMPOUNDING')}
                                      </label>
                                    )}
                                    {/* Affichage de quessCompounent (hors rôles additifs verificator / inventory — voir plus bas) */}
                                  {selectedGroup.quessCompounent &&
                                    selectedGroup.quessCompounent
                                      .filter(compounent => !ADDITIVE_COMPOUNDING_ROLES.includes(compounent.name))
                                      .map(compounent => (
                                      <div className="form-check" key={compounent.id}>
                                        <input
                                          value={compounent.id}
                                          className="form-check-input"
                                          type="checkbox"
                                          id={`inlineCheck-compounent-${compounent.id}`}
                                          checked={compounent.checked}
                                          onClick={() =>
                                            !compounent.checked &&
                                            handleChangeGroupRole(
                                              selectedGroup.groupId,
                                              compounent.id
                                            )
                                          }
                                          disabled={restore||!selectedGroup.valid}
                                        />
                                        <label className="form-label">
                                          {t(compounent.name)}
                                        </label>
                                      </div>
                                    ))}
                                  {/* verificator / inventory : rôles additifs, affichés comme des interrupteurs indépendants */}
                                  {selectedGroup.quessCompounent &&
                                    ADDITIVE_COMPOUNDING_ROLES
                                      .map(additiveName =>
                                        selectedGroup.quessCompounent.find(c => c.name === additiveName)
                                      )
                                      .filter(Boolean)
                                      .map(additiveRole => (
                                      <div className="verify-toggle-panel" key={`${additiveRole.name}-${selectedGroup.groupId}`}>
                                        <div>
                                          <div className="verify-toggle-label">{t(`${additiveRole.name}Access`)}</div>
                                          <div className="verify-toggle-help">{t(`${additiveRole.name}Help`)}</div>
                                        </div>
                                        <label className="verify-switch">
                                          <input
                                            type="checkbox"
                                            checked={additiveRole.checked}
                                            onClick={() => handleChangeGroupRole(selectedGroup.groupId, additiveRole.id)}
                                            disabled={restore||!selectedGroup.valid}
                                          />
                                          <span className="verify-switch-track"></span>
                                        </label>
                                      </div>
                                    ))}
                                </Col>
                                <Col lg={3}>
                                  <div className="form-check text-center">
                                    <button
                                      className="btn btn-outline-danger"
                                      style={{ borderRadius: "50%" }}
                                      type="button"
                                      onClick={() => removeGroup(selectedGroup.groupId)}
                                      disabled={!selectedGroup.valid}
                                    >
                                      <i className="fa fa-minus" />
                                    </button>
                                  </div>
                                </Col>
                              </Row>
                            ))}

                        </CardBody>
                      </Card>
                    </CardBody>
                  </Card>
                </Col>

                <Col lg={12} className="fixed-bottom-buttons">
                                <Row>
                                  <Col md={3}></Col>
                                    <Col md={5}>
                                   
                                    </Col>
                                    <Col md={4}>
                                    <div className="float-end">
                             
                                        <button
                                            type="submit"
                                            className="ms-1 btn btn-success me-3"
                                            disabled={isClicked}
                                        >
                                            {t("save")} 
                                        </button>
                                        <button
                                            type="reset"
                                            className="btn btn-info"
                                            onClick={() => goBack()}
                                        >
                                           {t("cancel")}
                                        </button>
                                    </div>
                                        </Col>
                                  </Row>
                                </Col>
              </Row>
            </Form>
            {showScrollTop && (
  <button
    onClick={scrollToTop}
    style={{
      position: "fixed",
      bottom: "80px",
      right: "30px",
      backgroundColor: "#17a2b8",
      color: "#fff",
      border: "none",
      borderRadius: "50%",
      width: "50px",
      height: "50px",
      fontSize: "20px",
      boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
      zIndex: 1000,
      cursor: "pointer",
    }}
    title={t("Back to top")}
  >
    ↑
  </button>
)}

            {userAddedMessage && (
              <div
                style={{
                  position: "fixed",
                  bottom: "10px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  padding: "10px 20px",
                  backgroundColor:
                    userAddedMessage.type === "success" ? "green" : "#ff3d60",
                  color: "white",
                  borderRadius: "5px",
                  zIndex: 1000,
                  minWidth: "25%",
                  textAlign: "center",
                  transition: "opacity 0.5s ease-in-out",
                }}
              >
                {userAddedMessage.text}
              </div>
            )}
          </div>

           </Card>
          
        </Container>)}
      </div>
    </React.Fragment>
  );
};

export default UpdateUser;
